export interface AdminDemoActor {
  email: string;
  role: string;
}

let currentRole: string | null = null;
let currentActor: AdminDemoActor | null = null;

export function setAdminDemoRole(role: string | null): void {
  currentRole = role;
}

export function getAdminDemoRole(): string {
  if (!currentRole) return 'superadmin';
  return currentRole;
}

export function setAdminDemoActor(actor: AdminDemoActor | null): void {
  currentActor = actor;
}

export function getAdminDemoActor(): AdminDemoActor {
  return currentActor ?? { email: 'admin@maktechacademy.com', role: 'superadmin' };
}
